<script setup lang="ts">
import type { Service } from '..';

defineProps<{ service: Service }>();
</script>

<template>
  <AppLink
    type="custom"
    :to="service.url"
    :opts="{}"
    class="group/exercise-card relative cursor-pointer overflow-hidden rounded-2xl select-none"
  >
    <ServicesExerciseCardBackground
      :image="{ url: service.image, alt: service.title }"
    />
    <ServicesExerciseCardArrow />
    <ServicesExerciseCardContent
      :title="service.title"
      :description="service.paragraph"
      :icon="service.icon"
    />
  </AppLink>
</template>
